import React from 'react'
import { Dejargonator, TextBody } from '@ally/metronome-ui'
import { AccountDetails } from '../../../types'
import {
  AcctDetailsItem,
  Dt,
  Dd,
  StyledDejargTrigger,
} from './StyledDlElements'

interface TotalAllowedRateIncreasesProps {
  account: AccountDetails
}

export const TotalAllowedRateIncreasesDl: React.FC<TotalAllowedRateIncreasesProps> =
  ({ account }) =>
    account.ryrAvailableIndicator &&
    account.totalAllowedRateIncreases !== undefined &&
    account.ryrIncreasesUsed !== undefined ? (
      <AcctDetailsItem>
        <Dt>
          <Dejargonator
            trigger={{
              content: (
                <StyledDejargTrigger>
                  <TextBody size="sm" tag="dt" weight="bold">
                    Available Rate Increases:
                  </TextBody>
                </StyledDejargTrigger>
              ),
              variant: 'element',
              ariaLabel: 'available rate increases',
            }}
            body="Available Rate Increases shows how many rate increases you have available now versus the number you had at the beginning of your CD term. You can raise your rate to Ally's Current APY once for a 2-year CD or twice for a 4-year CD - at no cost to you."
            ariaLabelPopover="Available Rate Increases shows how many rate increases you have
              available now versus the number you had at the beginning of your
              CD term."
          />
        </Dt>
        <Dd>
          {account.totalAllowedRateIncreases !== undefined &&
            account.ryrIncreasesUsed !== undefined &&
            `${
              account.totalAllowedRateIncreases - account.ryrIncreasesUsed
            } of ${account.totalAllowedRateIncreases}`}
        </Dd>
      </AcctDetailsItem>
    ) : // istanbul ignore next
    null
